module.exports = __webpack_public_path__ + "img/trio-page-2-silex.ea88e75b.jpg";